const avTypeMapping = {
    video: 'video',
    vod: 'video',
    audio: 'audio',
    aod: 'audio'
};
export function getAVType(avType) {
    return avTypeMapping[avType];
}
